<script lang="ts">
  import type { Localizer } from "../../l10n/localization.service";

  export let T: Localizer;
</script>

<div class="required">
  {T.get("required")}
</div>

<style lang="scss">
  .required {
    grid-area: subtitle;
    font-size: 12px;
    font-weight: 400;
    text-align: right;
    margin-top: 0.5rem;
  }
</style>
